import createSvgIcon from '../createSvgIcon';
export default createSvgIcon(
  <g fill="none" fillRule="evenodd">
    <circle cx="12" cy="12" r="12" fill="#FFF" />
    <path
      fill="#4285F4"
      fillRule="nonzero"
      d="M20.64 12.20455c0-.63819-.05727-1.25182-.16364-1.84091H12V13.845h4.84364c-.20864 1.125-.84273 2.07818-1.79591 2.71636v2.25819h2.90863c1.70182-1.56682 2.68364-3.8741 2.68364-6.615z"
    />
    <path
      fill="#34A853"
      fillRule="nonzero"
      d="M12 21c2.43 0 4.46727-.8059 5.95636-2.18045l-2.90863-2.25819c-.80591.54-1.83682.8591-3.04773.8591-2.3441 0-4.32818-1.58319-5.0359-3.71046H3.95726v2.33182C5.43818 18.98318 8.48182 21 12 21z"
    />
    <path
      fill="#FBBC05"
      fillRule="nonzero"
      d="M6.9641 13.71c-.18-.54-.28228-1.11682-.28228-1.71s.10227-1.17.28227-1.71V7.95818H3.95727C3.34773 9.17318 3 10.54773 3 12c0 1.45227.34773 2.82682.95727 4.04182L6.9641 13.71z"
    />
    <path
      fill="#EA4335"
      fillRule="nonzero"
      d="M12 6.57955c1.32136 0 2.50773.45409 3.44045 1.3459l2.58137-2.58136C16.46318 3.89182 14.4259 3 12 3 8.48182 3 5.43818 5.01682 3.95727 7.95818L6.9641 10.29C7.67182 8.16273 9.65591 6.57955 12 6.57955z"
    />
    <path d="M3 3h18v18H3z" />
  </g>,
  'GoogleIcon',
  '',
  false,
);
